<template>
    <div v-if="dataSource" class="p-relative">

        <Toolbar                         
            v-on:toolbar-button-click="onToolbarClick"  
        > 
            <!--Панель поиска-->
            <SearchPanel
                v-model="search"
                :has-filter="true"
                @on-filter-click="onFilterClick"
            />
        </Toolbar>

        <FilterPanel
            v-if="filterDataSource"
            :dataSource="filterDataSource"
            v-bind:status.sync="status"
        >
            <ExtendedFilterPanel
                v-if="$helpers.isExtendedFilterPanelVisible(extendedTableFilter)"
                v-bind:value.sync="extendedTableFilter"
            />
        </FilterPanel>

        <v-row no-gutters>
            <v-col cols="12" xs="12" md="12">
                <v-data-table
                    :loading="loading"
                    :headers="headers"
                    :items="entities"
                    :item-class="itemRowBackground"
                    :options.sync="options"
                    :server-items-length="total"
                    :items-per-page="10"
                    :footer-props="{ itemsPerPageOptions:[5, 10, 20] }"
                    :page.sync="options.page"
                    @page-count="paginationPageCount = $event"
                    class="elevation-1 customization-list-table pagination-list-table sticky-table"
                    @dblclick:row="(event, data) => $eventBus.$emit('open-document', { id: data.item.id, type: 'Chancellery|Documents.Document' })"
                >

                    <v-progress-linear slot="progress" height="2" color="#E43958" indeterminate></v-progress-linear>

                    <template v-slot:[`item.regdate`]="{ item }">
                        <div>{{dateFormat(item.regdate, 'DD.MM.YYYY')}}</div>
                    </template>

                    <template v-slot:[`item.declarant`]="{ item }">
                        <div class="elipsis-text-wrap">
                            {{ item.declarant }}
                        </div>
                    </template>
                    
                    <template v-slot:[`item.contracttimeend`]="{ item }">
                        <div>{{ item.contracttimeend ? item.contracttimeend : $t('Бессрочный') }}</div>
                    </template>

                    <template v-slot:[`footer.prepend`]>
                        <v-pagination
                            v-model="options.page"
                            :length="paginationPageCount"
                            :total-visible="$listPaginationTotal"
                            color="teal"
                        ></v-pagination>
                    </template>

                </v-data-table>
            </v-col>
        </v-row>

        <QalaQyzmetContractsExFilterDlg
            v-model="extendedTableFilter" 
            ref="QalaQyzmetContractsExFilterDlgRef" 
        />

    </div>
</template>

<script>
import Axios from 'axios';
import _ from 'lodash';
import { httpAPI } from "@/api/httpAPI";
import sys from "@/services/system";
import { mapActions } from 'vuex';
import SearchPanel from '@/components/documents/SearchPanel.vue';
import FilterPanel from '@/components/documents/FilterPanel.vue';
import ExtendedFilterPanel from '@/components/documents/ExtendedFilterPanel.vue';
import Toolbar from '@/components/documents/Toolbar.vue';
import QalaQyzmetContractsExFilterDlg from '@/components/qala-qyzmet/dialogs/extended-filters/Contracts.vue';

export default {
    name: "QalaQyzmetContracts",
    components: {
        SearchPanel,
        FilterPanel,
        ExtendedFilterPanel,
        Toolbar,
        QalaQyzmetContractsExFilterDlg
    },
    data () {
        return {
            loading: true,
            cancellationTokenSorce: null,

            dataSource: null,
            filterDataSource: null,

            total: 0,
            entities: [],
            prevTableFilterObject: null,
            paginationPageCount: 0
        }
    },
    computed: {
        collection () {
            return "Contracts";
        },
        status: {
            get: function() {
                return this.$store.getters['qalaQyzmet/contracts/getStatus'];
            },
            set: function(newValue) {
                this.resetPage();
                this.$store.commit('qalaQyzmet/contracts/SET_STATUS', newValue);
            }
        },
        headers() {
            return [
                { text: this.$t("Дог._№"), value: 'regnumber', width: '150px', orderby: 2 },
                { text: this.$t("Дог._дата"), value: 'regdate', width: '150px', orderby: 3 },
                { text: this.$t("С_кем_заключен"), value: 'declarant', width: '15%', orderby: 4 },
                { text: this.$t("Суть_договора"), value: 'annotation', orderby: 5 },
                //{ text: this.$t("Срок_действия"), value: 'contracttimeend', width: '150px', orderby: 6 }
            ]
        },
        options: {
            get: function() {
                return this.$store.getters['qalaQyzmet/contracts/getTableOptions'];
            },
            set: function(newValue) {
                this.$store.commit('qalaQyzmet/contracts/SET_TABLE_OPTION', newValue);
            }
        },
        search: {
            get: function() {
                return this.$store.getters['qalaQyzmet/contracts/getSearch'];
            },
            set: _.debounce(function(newValue) {
                this.resetPage();
                this.$store.commit('qalaQyzmet/contracts/SET_SEARCH', newValue);
            }, 250),
        },
        extendedTableFilter: {
            get: function() {
                return this.$store.getters['qalaQyzmet/contracts/getExtendedFilter'];
            },
            set: function(newValue) {
                this.resetPage();
                this.$store.commit('qalaQyzmet/contracts/SET_EXTENDED_FILTER', newValue);
            }
        },        
        filter () {
            return {
                ...this.options,
                SearchStr: this.search,
                extendedFilterData: this.$helpers.getOnlySelectedParams(this.extendedTableFilter)
            }
        }
    },
    methods: {
        ...mapActions(['setOverlayVisible']),
        dateFormat: sys.dateFormat,
        resetPage() {
            this.$store.commit('qalaQyzmet/contracts/SET_TABLE_OPTION_PAGE', 1);
        },
        itemRowBackground (item) {
            return item.readed === true ? '' : 'font-weight-bold';
        },
        async loadButtons() {
            this.setOverlayVisible({ visible: true });
            
            let response = await httpAPI({
                url: `api/actions/collection?type=Documents.Correspondence.Contracts`,
                method: 'GET'
            });

            if (response) {
                await this.loadFilters();
                this.dataSource = response.data.Payload;
                this.$store.commit('documents/toolbar/SET_MENU', {menu: this.dataSource.Data.Menu });
            }
            
            this.setOverlayVisible({ visible: false });
        },
        async loadFilters() {
            let filterResponse = await httpAPI({
                url: `api/csc/contract/filter`,
                method: 'GET'
            });

            if (filterResponse) {
                var filter = filterResponse.data.Payload.Filter.Items.find(x => x.Value == this.collection);
                this.filterDataSource = { Filter: filter?.Items }
            }
        },
        async getData (isRefresh = false) {
            if (isRefresh === false && this.$_.isEqual(this.prevTableFilterObject, this.getTableFilterObject()))
                return;
            
            this.prevTableFilterObject = this.getTableFilterObject();
            this.total = 0;
            this.entities = [];
            this.loading = true;

            if (this.cancellationTokenSorce)
                this.cancellationTokenSorce.cancel('New request started');

            this.cancellationTokenSorce = Axios.CancelToken.source();

            let response = await httpAPI({
                url: `api/correspondence/list?collection=${this.collection}&filter=${JSON.stringify(this.getTableFilterObject())}`,
                method: 'GET',
                cancelToken: this.cancellationTokenSorce.token,
            });

            this.entities = response?.data?.Payload?.data ?? [];
            this.total = response?.data?.Payload?.total ?? 0;
            this.loading = false;
        },
        getTableFilterObject() {
            var { sortBy, sortDesc, page, itemsPerPage, SearchStr, extendedFilterData } = this.filter;
            let OrderDir = sortDesc.length <= 0 ? false : sortDesc[0];
            let OrderBy = this.headers.find(i => i.value == (sortBy.length <= 0 ? 'null' : sortBy[0]))?.orderby ?? -1;
            return { SearchStr, OrderBy, OrderDir, Limit: itemsPerPage, Offset: (page - 1) * itemsPerPage, ...extendedFilterData };
        },        
        async onFilterClick() {
            try
            {
                await this.$refs.QalaQyzmetContractsExFilterDlgRef.open()
            }
            catch (ex)
            {
                if (ex.isCancelled) 
                    console.warn(ex.message);
                else
                    console.error(ex.message);
            }
        },        
        onToolbarClick(event, btn) {
            let method = this[btn.Action];

            if (method)
                method(btn);
            else
                this.$notify.alert(`Действие ${btn.Action} не реализовано`);
        },
        async Refresh() {
            await this.loadFilters();
            await this.getData(true);
        },
        async Export() {
            let filter = this.getTableFilterObject();
            delete filter.Limit;
            delete filter.Offset;
            let exportURI = `api/csc/contracts/export?filter=${JSON.stringify(filter)}`;
            this.$eventBus.$emit('on-get-report', { url: exportURI, text: this.$t('Экспорт_списка_договоров_от_date.message', {date:  this.$moment().format('DD.MM.YYYY HH.mm.ss')}), type: 'Xls' });
        },
    },
    watch: {
        filter: {
            handler () {
                this.getData()
            },
            deep: true,
        }
    },
    async created() {
        this.loadButtons();
    }
}
</script>